export class PoiCategoryRegionFilterModel {
  propertyNames?: string[];
  searchValues?: string[];
  and?: boolean;
  orderColumn?: string;
  order?: string;
  index!: number;
  size!: number;
  isProcessed?: boolean | null;
}
